import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1969f753"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blurredStripe" }
const _hoisted_2 = { class: "controlPanel" }
const _hoisted_3 = { class: "controlPanelContent" }
const _hoisted_4 = { class: "displayName" }
const _hoisted_5 = { class: "controls" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filler" }, null, -1))

import { Room } from "twilio-video";
import ToggleCameraButton from "../ToggleCameraButton/ToggleCameraButton.vue";
import ToggleMicrophoneButton from "../ToggleMicrophoneButton/ToggleMicrophoneButton.vue";
import HangUpButton from "../HangUpButton/HangUpButton.vue";

interface Props {
  room: Room | null;
  displayName: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CallControlPanel',
  props: {
    room: { default: null },
    displayName: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.displayName), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ToggleCameraButton),
          _createVNode(ToggleMicrophoneButton),
          _createVNode(HangUpButton, { room: _ctx.room }, null, 8, ["room"])
        ]),
        _hoisted_6
      ])
    ])
  ]))
}
}

})